import {
    OnInit,
    Component,
    Input,
    Output,
    EventEmitter,

    ViewChild,
    Injector,
    ElementRef,
    ComponentFactory,
    ComponentFactoryResolver
} from '@angular/core';

import { IconPixelComponent } from '../icon-pixel.component';
import { IconCpuUnlockComponent } from '../icon-cpu-unlock.component';
import { IconAccessKeyComponent } from '../icon-access-key.component';

@Component({
    selector: 'app-inventory-transfer',
    templateUrl: './transfer.component.pug',
    styleUrls: ['./transfer.component.less'],
})
export class TransferComponent implements OnInit {
    public value: number = 1;

    @Input() limit: number = 100;
    @Input() title: string = '';
    @Input() button: string = '';

    @ViewChild('button', { static: true }) buttonRef: ElementRef;

    @Output() transfer: EventEmitter<any> = new EventEmitter();

    _componentRef: any;
    _componentFactories: Map<string, ComponentFactory<IconPixelComponent | IconCpuUnlockComponent | IconAccessKeyComponent>> = new Map();

    constructor(
        private _resolver: ComponentFactoryResolver,
        private _injector: Injector
    ) {
        this._componentFactories.set('app-icon-pixel', this._resolver.resolveComponentFactory(IconPixelComponent));
        this._componentFactories.set('app-icon-cpu-unlock', this._resolver.resolveComponentFactory(IconCpuUnlockComponent));
        this._componentFactories.set('app-icon-access-key', this._resolver.resolveComponentFactory(IconAccessKeyComponent));
    }

    ngOnInit() {
        this.buttonRef.nativeElement.innerHTML = this.button;
        const children = this.buttonRef.nativeElement.children;

        for (let i = 0; i < children.length; i++) {
            const el = children[i];

            this._componentRef = this._componentFactories.get(el.tagName.toLowerCase()).create(this._injector, [], el);
            this.onChange(this.value);
        }
    }

    onChange(value) {
        this.value = value;

        if (!this._componentRef) {
            return;
        }

        this._componentRef.instance.setValue(value);
        this._componentRef.changeDetectorRef.detectChanges();
    }

    onTransfer() {
        this.transfer.emit(this.value);
    }
}
